import { useState } from 'react';
import { Lock, AlertCircle } from 'lucide-react';

function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // 简单的密码验证（实际应该验证 API Key）
    // 这里使用输入的密码作为管理密码
    if (password.length < 6) {
      setError('密码至少需要 6 个字符');
      setLoading(false);
      return;
    }

    // 保存密码到 localStorage
    localStorage.setItem('qianshu_admin_password', password);
    
    setLoading(false);
    onLogin();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-600 rounded-full mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">乾枢管理后台</h1>
          <p className="text-gray-600">请输入管理密码</p>
        </div>

        {error && (
          <div className="card bg-red-50 border-red-200 mb-6">
            <div className="flex items-center text-red-800">
              <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0" />
              <span>{error}</span>
            </div>
          </div>
        )}

        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="label">管理密码</label>
              <input
                type="password"
                className="input"
                placeholder="请输入密码（至少 6 位）"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
              <p className="mt-2 text-sm text-gray-500">
                💡 提示：首次访问时设置的密码将作为管理密码
              </p>
            </div>

            <button
              type="submit"
              className="btn-primary w-full"
              disabled={loading}
            >
              {loading ? '登录中...' : '登录'}
            </button>
          </form>
        </div>

        <div className="mt-6 card bg-blue-50 border-blue-200">
          <p className="text-sm text-blue-800">
            🔒 密码将保存在浏览器本地，请妥善保管。如果忘记密码，需要清除浏览器缓存后重新设置。
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
